import { COMMON_NAMESPACE } from '@porsche-code/kado-i18n';
import { styled } from '@porsche-code/kado-styled-system/jsx';
import { Spacer } from '@porsche-code/kado-ui';
import NotLoggedInIcon from '@porsche-code/kado-ui/icons/not-logged-in.svg?react';
import {
  PHeading,
  PLink,
  PText,
} from '@porsche-design-system/components-react';
import { useTranslation } from 'react-i18next';

import { getPpnSlug } from './helpers';

const Wrapper = styled('div', {
  base: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'xl',
  },
});

const Icon = styled(NotLoggedInIcon, {
  base: {
    fontSize: '180px',
    my: 'xl',
    mx: 0,
  },
});

export const NotSignedIn = () => {
  const { t } = useTranslation(COMMON_NAMESPACE);
  const ppnSlug = getPpnSlug();

  const PPN_URL = `https://${ppnSlug}.porsche.com/`;

  return (
    <Wrapper>
      <PHeading tag="h3" size="xl">
        {t('notLoggedIn.title')}
      </PHeading>
      <Icon />
      <PText align="center">{t('notLoggedIn.text')}</PText>
      <Spacer mt="md" />
      <PLink href={PPN_URL}>{t('notLoggedIn.goToPPN')}</PLink>
    </Wrapper>
  );
};
